var _style, _g, _g2, _defs, _rect, _g3, _g4, _g5, _path, _g6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g7, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g8, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g9, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g10, _path50, _g11, _g12, _polygon, _g13, _path51, _path52, _path53, _path54, _path55, _g14, _g15, _g16, _g17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationNotfound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 320",
    style: {
      enableBackground: "new 0 0 500 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill:url(#XMLID_650_);}\n\t.st2{opacity:0.5;mask:url(#fond_gradient_8_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#C3CAE5;}\n\t.st4{fill:#CACDD8;}\n\t.st5{fill:#E2E5ED;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#EBEEF7;}\n\t.st8{fill:url(#XMLID_794_);}\n\t.st9{fill:url(#XMLID_795_);}\n\t.st10{fill:#9FA9BF;}\n\t.st11{fill:#C3CAE5;}\n\t.st12{fill:#FF4137;}\n\t.st13{fill:#17152B;}\n\t.st14{fill:#AF1B1B;}\n\t.st15{fill:#CE2424;}\n\t.st16{fill:#F2BBB8;}\n\t.st17{fill:#9297A5;}\n\t.st18{fill:#E59095;}\n\t.st19{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st20{fill:url(#XMLID_796_);}\n\t.st21{opacity:0.5;mask:url(#fond_gradient_9_);}\n\t.st22{fill:url(#XMLID_797_);}\n\t.st23{fill:#74BDDE;}\n\t.st24{fill:#63B3CE;}\n\t.st25{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st26{fill:url(#XMLID_798_);}\n\t.st27{opacity:0.5;mask:url(#fond_gradient_10_);}\n\t.st28{opacity:0.35;}\n\t.st29{fill:url(#XMLID_799_);}\n\t.st30{fill:url(#XMLID_800_);}\n\t.st31{fill:url(#XMLID_801_);}\n\t.st32{fill:url(#XMLID_802_);}\n\t.st33{fill:#303747;}\n\t.st34{fill:#1B202D;}\n\t.st35{fill:#DEF5FF;}\n\t.st36{fill:#6B707C;}\n\t.st37{fill:#20232E;}\n\t.st38{fill:#F1917C;}\n\t.st39{fill:#FF4A2F;}\n\t.st40{fill:#FAFAFC;}\n\t.st41{fill:url(#XMLID_803_);}\n\t.st42{opacity:0.48;fill:#C3CAE5;}\n\t.st43{opacity:0.64;fill:#FFFFFF;}\n\t.st44{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st45{fill:url(#XMLID_804_);}\n\t.st46{opacity:0.5;mask:url(#fond_gradient_11_);}\n\t.st47{fill:url(#XMLID_805_);}\n\t.st48{fill:url(#XMLID_806_);}\n\t.st49{fill:url(#XMLID_807_);}\n\t.st50{fill:url(#XMLID_808_);}\n\t.st51{fill:#D13119;}\n\t.st52{fill:#495363;}\n\t.st53{fill:#91B5F8;}\n\t.st54{fill:#FFA1A1;}\n\t.st55{filter:url(#Adobe_OpacityMaskFilter_4_);}\n\t.st56{fill:url(#XMLID_809_);}\n\t.st57{opacity:0.5;mask:url(#fond_gradient_12_);}\n\t.st58{fill:#060633;}\n\t.st59{fill:#EA6868;}\n\t.st60{fill:#240D39;}\n\t.st61{fill:#272035;}\n\t.st62{fill:#3C414C;}\n\t.st63{fill:#575756;}\n\t.st64{fill:#9B9B9B;}\n\t.st65{fill:url(#XMLID_810_);}\n\t.st66{clip-path:url(#XMLID_812_);}\n\t.st67{clip-path:url(#XMLID_814_);}\n\t.st68{clip-path:url(#XMLID_816_);}\n\t.st69{fill:url(#XMLID_817_);}\n\t.st70{filter:url(#Adobe_OpacityMaskFilter_5_);}\n\t.st71{fill:url(#XMLID_818_);}\n\t.st72{opacity:0.5;mask:url(#fond_gradient_13_);}\n\t.st73{opacity:0.46;fill:#CACDD8;}\n\t.st74{fill:url(#XMLID_819_);}\n\t.st75{fill:url(#XMLID_820_);}\n\t.st76{fill:#FB9391;}\n\t.st77{fill:none;stroke:#7F7EA3;stroke-width:0.2;stroke-miterlimit:10;}\n\t.st78{fill:#0B0755;}\n\t.st79{fill:#7C9AF2;}\n\t.st80{fill:#E57A7A;}\n\t.st81{filter:url(#Adobe_OpacityMaskFilter_6_);}\n\t.st82{fill:url(#XMLID_821_);}\n\t.st83{opacity:0.5;mask:url(#fond_gradient_14_);}\n\t.st84{clip-path:url(#XMLID_825_);}\n\t.st85{fill:#FFAB95;}\n\t.st86{fill:#BEC2CC;}\n\t.st87{fill:#B0D882;}\n\t.st88{clip-path:url(#XMLID_826_);fill:#9297A5;}\n\t.st89{clip-path:url(#XMLID_826_);fill:#1B202D;}\n\t.st90{clip-path:url(#XMLID_826_);fill:#FF4137;}\n\t.st91{clip-path:url(#XMLID_826_);}\n\t.st92{filter:url(#Adobe_OpacityMaskFilter_7_);}\n\t.st93{fill:url(#XMLID_827_);}\n\t.st94{opacity:0.5;mask:url(#fond_gradient_15_);}\n\t.st95{fill:#444A56;}\n\t.st96{fill:#F4CECE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 57.5,
    y: 12.9,
    width: 407.8,
    height: 271.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 57.5,
    y: 12.9,
    width: 407.8,
    height: 271.8,
    id: "fond_gradient_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_305_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_650_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.3237,
    y1: 281.6369,
    x2: 308.3237,
    y2: 22.3958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_306_",
    x: -32,
    y: 30.2,
    className: "st1",
    width: 680.7,
    height: 252.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fond_gradient_2_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9589_",
    className: "st3",
    d: "M436.3,284.7c0-5.2-80.4-9.4-179.6-9.4c-99.2,0-179.6,4.2-179.6,9.4 c-14.8-14.5-22.7-41.4-18.4-61.7c4.3-20.3,23.3-37.6,23.7-58.4c0.7-34.3-20.7-69.2-8.6-101.4c9.8-26,34.9-50.4,67.7-50.4 c27.8,0,58.5,15.3,83.3,27.6c24.9,12.3,46.4,26.3,73.9,30.2c19.5,2.8,42.5,1.3,62,4c43.3,6,82.3,37.8,97,79 C472.4,194.9,466,252.6,436.3,284.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1969_",
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9501_",
    className: "st11",
    d: "M380,241.3c0,0-0.1,0-0.1,0c-0.3,0-0.5-0.3-0.5-0.6c8.4-75.3,18.7-129.2,29-151.9 c0.2-0.5,0.4-0.9,0.4-1c0.1-0.3,0.4-0.4,0.7-0.3c0.3,0.1,0.4,0.4,0.3,0.7c-0.1,0.2-0.2,0.6-0.5,1.2 c-10.3,22.6-20.5,76.4-28.9,151.6C380.4,241.1,380.2,241.3,380,241.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9500_",
    className: "st11",
    d: "M417.4,83.3c-1.2,2.6-8.8,8.2-9.6,7.9c-0.7-0.4-1-9.8,0.3-12.4c1.2-2.6,4.3-3.6,6.9-2.4 C417.6,77.7,418.7,80.8,417.4,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9499_",
    className: "st11",
    d: "M402.6,93.1c1.3,2.6,1.3,12.3,0.6,12.7c-0.7,0.4-8.6-5.3-9.9-7.9c-1.3-2.6-0.3-5.8,2.3-7.1 C398.1,89.5,401.3,90.5,402.6,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9498_",
    className: "st11",
    d: "M415.5,107.7c-2.8,0.7-12.3-1.5-12.5-2.3c-0.2-0.8,7.1-7.2,9.9-7.9c2.8-0.7,5.7,1,6.4,3.8 C420.1,104.1,418.4,107,415.5,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9497_",
    className: "st11",
    d: "M386.8,144.9c2.7,4.1,4.4,20.3,3.2,21c-1.2,0.8-15.3-7.2-18-11.3 c-2.7-4.1-1.5-9.6,2.5-12.3C378.6,139.7,384.1,140.8,386.8,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9496_",
    className: "st11",
    d: "M411,166.9c-4.6,1.7-20.7-0.3-21.2-1.6c-0.5-1.3,10.5-13.3,15.1-15 c4.6-1.7,9.7,0.7,11.4,5.2C417.9,160.1,415.6,165.2,411,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9495_",
    className: "st11",
    d: "M377.5,165.1c4.3,4.2,10.7,23,9.5,24.2c-1.2,1.2-20.2-4.5-24.5-8.6 c-4.3-4.2-4.4-11-0.3-15.3C366.4,161,373.2,160.9,377.5,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9494_",
    className: "st11",
    d: "M411.6,193.3c-5.8,1.5-25.2-3-25.6-4.6c-0.4-1.7,14.4-14.9,20.2-16.4 c5.8-1.5,11.7,2,13.2,7.8C420.9,186,417.4,191.9,411.6,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9493_",
    className: "st11",
    d: "M374,189.7c4.3,4.2,10.7,23,9.5,24.2c-1.2,1.2-20.2-4.5-24.5-8.6c-4.3-4.2-4.4-11-0.3-15.3 C362.9,185.7,369.7,185.6,374,189.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9419_",
    className: "st11",
    d: "M408.1,218c-5.8,1.5-25.2-3-25.6-4.6c-0.4-1.7,14.4-14.9,20.2-16.4 c5.8-1.5,11.7,2,13.2,7.8C417.4,210.6,413.9,216.5,408.1,218z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9418_",
    className: "st11",
    d: "M362.4,222.1c5.6,2.2,18.6,17.2,18,18.8c-0.6,1.6-20.4,3.6-26,1.4 c-5.6-2.2-8.3-8.5-6.1-14.1C350.6,222.6,356.9,219.9,362.4,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9417_",
    className: "st11",
    d: "M405.5,242.3c-5.6,2.2-25.4,0.2-26-1.4c-0.6-1.6,12.5-16.6,18-18.8 c5.6-2.2,11.9,0.5,14.1,6.1C413.8,233.8,411.1,240.1,405.5,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9416_",
    className: "st11",
    d: "M397.7,109.3c1.3,2.6,1.3,12.5,0.6,12.9c-0.8,0.4-8.8-5.3-10.1-8c-1.3-2.6-0.3-5.9,2.3-7.2 C393.2,105.6,396.4,106.6,397.7,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9415_",
    className: "st11",
    d: "M410.5,124.3c-2.9,0.7-12.5-1.5-12.7-2.3c-0.2-0.8,7.2-7.3,10-8c2.9-0.7,5.8,1,6.5,3.9 C415.2,120.7,413.4,123.6,410.5,124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2036_",
    className: "st11",
    d: "M391.6,124.5c2.2,3.6,3.3,17.5,2.3,18.1c-1,0.6-13-6.5-15.2-10.1 c-2.2-3.6-1.1-8.3,2.5-10.5C384.7,119.8,389.4,120.9,391.6,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1971_",
    className: "st11",
    d: "M411.7,145.5c-4.1,1-17.7-2.2-18-3.3c-0.3-1.2,10.2-10.4,14.3-11.4c4.1-1,8.2,1.5,9.2,5.5 C418.2,140.4,415.8,144.5,411.7,145.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1909_",
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1967_",
    className: "st11",
    d: "M156.1,254.1C156.1,254.1,156.2,254.1,156.1,254.1c0.3-0.1,0.4-0.3,0.3-0.6 c-19.5-57.4-36.9-97.8-48.8-113.8c-0.3-0.4-0.5-0.6-0.5-0.7c-0.1-0.2-0.4-0.3-0.6-0.2c-0.2,0.1-0.3,0.4-0.2,0.6 c0.1,0.2,0.3,0.4,0.6,0.8c11.9,15.9,29.2,56.2,48.7,113.5C155.7,254,155.9,254.1,156.1,254.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1966_",
    className: "st11",
    d: "M99.6,137.1c1.4,1.8,8.3,4.9,8.8,4.5c0.5-0.4-0.9-7.8-2.4-9.6c-1.4-1.8-4-2.1-5.8-0.7 C98.5,132.7,98.2,135.3,99.6,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1954_",
    className: "st11",
    d: "M112.9,142.2c-0.6,2.3,1.1,9.8,1.8,10c0.6,0.2,5.8-5.6,6.4-7.9c0.6-2.3-0.8-4.6-3-5.2 C115.8,138.6,113.5,139.9,112.9,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1928_",
    className: "st11",
    d: "M105.3,155.8c2.3,0.1,9.3-3.3,9.3-4c0-0.7-6.8-4.4-9.1-4.5c-2.3-0.1-4.3,1.8-4.3,4.1 C101.1,153.8,102.9,155.7,105.3,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1926_",
    className: "st11",
    d: "M134.2,179.9c-1.4,3.7,0.1,16.6,1.1,17c1,0.4,10.7-8.3,12.1-11.9c1.4-3.7-0.4-7.8-4.1-9.1 C139.7,174.4,135.6,176.3,134.2,179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1924_",
    className: "st11",
    d: "M119,201.3c3.9,0.5,16.2-3.8,16.3-4.9c0.2-1.1-10.5-8.6-14.4-9.1c-3.9-0.5-7.5,2.2-8,6.1 C112.4,197.2,115.1,200.7,119,201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1923_",
    className: "st11",
    d: "M144.9,194.1c-2.6,4-4.4,19.8-3.2,20.6c1.1,0.8,15.1-7,17.7-11c2.6-4,1.6-9.4-2.4-12 C152.9,189,147.5,190.1,144.9,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1922_",
    className: "st11",
    d: "M123.1,222.1c4.8,0.2,19.2-6.7,19.2-8c0-1.4-13.9-9.1-18.6-9.3c-4.8-0.2-8.8,3.6-9,8.4 C114.6,217.9,118.3,221.9,123.1,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1921_",
    className: "st11",
    d: "M151.9,212.8c-2.6,4-4.4,19.8-3.2,20.6c1.1,0.8,15.1-7,17.7-11c2.6-4,1.6-9.4-2.4-12 C159.9,207.7,154.5,208.8,151.9,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1920_",
    className: "st11",
    d: "M130.1,240.8c4.8,0.2,19.2-6.7,19.2-8c0-1.4-13.9-9.1-18.6-9.3c-4.8-0.2-8.8,3.6-9,8.4 C121.5,236.6,125.3,240.6,130.1,240.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1919_",
    className: "st11",
    d: "M166.5,236.1c-4,2.7-11.6,16.7-10.8,17.8c0.8,1.1,16.6-0.7,20.6-3.4c4-2.7,5-8.1,2.3-12 C175.9,234.4,170.5,233.4,166.5,236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1918_",
    className: "st11",
    d: "M136.3,259.3c4.7,0.8,19.9-4.2,20.1-5.6c0.2-1.3-12.6-10.8-17.3-11.6 c-4.7-0.8-9.2,2.5-9.9,7.2C128.4,254.1,131.6,258.5,136.3,259.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1917_",
    className: "st11",
    d: "M119.5,153.9c-0.6,2.3,1.1,10,1.8,10.2c0.7,0.2,5.9-5.7,6.5-8c0.6-2.3-0.8-4.6-3.1-5.2 C122.4,150.3,120.1,151.6,119.5,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1915_",
    className: "st11",
    d: "M112,167.9c2.4,0.1,9.5-3.3,9.5-4c0-0.7-6.9-4.5-9.2-4.6c-2.4-0.1-4.3,1.8-4.4,4.2 C107.8,165.9,109.7,167.8,112,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1913_",
    className: "st11",
    d: "M126.9,164.8c-1.1,3.2,0.4,14.3,1.3,14.6c0.9,0.3,9-7.4,10.2-10.5c1.1-3.2-0.6-6.7-3.7-7.8 C131.5,160,128,161.6,126.9,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1911_",
    className: "st11",
    d: "M114.8,184.7c3.4,0.1,13.5-4.7,13.5-5.7c0-1-9.8-6.4-13.1-6.5c-3.4-0.1-6.2,2.6-6.3,5.9 C108.8,181.8,111.4,184.6,114.8,184.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "feuilles1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9521_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_794_",
    gradientUnits: "userSpaceOnUse",
    x1: -601.6228,
    y1: 1983.6707,
    x2: -601.6228,
    y2: 2088.3647,
    gradientTransform: "matrix(0.5372 -0.8435 0.8435 0.5372 -1329.6907 -1350.4513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4137"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9536_",
    className: "st8",
    d: "M19.4,221.9c0,0,13.3,33.8,46.4,54.9C98.9,297.9,109,279,109,279s12.9-17.1-20.2-38.2 C55.7,219.7,19.4,221.9,19.4,221.9z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9534_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9535_",
    className: "st6",
    d: "M109.4,279.2c-0.1,0.1-0.3,0.2-0.4,0.1l-81.7-52c-0.1-0.1-0.2-0.3-0.1-0.4 c0.1-0.1,0.3-0.2,0.4-0.1l81.7,52C109.4,278.9,109.5,279.1,109.4,279.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9533_",
    className: "st6",
    d: "M47.4,239.6c0-0.1,1.5-8.3-1-15.4c-0.2,0-0.4-0.1-0.7-0.1c2.6,7,1.1,15.3,1.1,15.4 L47.4,239.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9532_",
    className: "st6",
    d: "M32.1,229.9c0-0.1,0.6-3.4,0.4-7.6c-0.2,0-0.4,0-0.6,0c0.2,4.2-0.4,7.5-0.4,7.5L32.1,229.9 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9531_",
    className: "st6",
    d: "M55.4,244.7c0-0.1,1.9-10.7-1.9-18.9c-0.3-0.1-0.5-0.1-0.8-0.2c4,8,2.1,18.8,2.1,19 L55.4,244.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9530_",
    className: "st6",
    d: "M90.1,266.8c0-0.2,2.8-15.6-3-27.1c-0.3-0.2-0.7-0.4-1-0.6c6.3,11.4,3.4,27.4,3.4,27.6 L90.1,266.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9528_",
    className: "st6",
    d: "M102.3,274.8l0.6,0.1c0-0.2,2.4-13.7-2-24.9c-0.3-0.3-0.7-0.7-1.1-1 C104.9,260.2,102.3,274.7,102.3,274.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9527_",
    className: "st6",
    d: "M68.9,253.4c0-0.2,2.3-12.9-1.9-23.4c-0.3-0.1-0.5-0.2-0.8-0.3c4.4,10.4,2.1,23.4,2.1,23.6 L68.9,253.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9526_",
    className: "st6",
    d: "M29.8,240.9c6.2-1.5,11.2-5,11.3-5.1l-0.3-0.5c-0.1,0.1-5.1,3.6-11.3,5 C29.5,240.5,29.7,240.7,29.8,240.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9525_",
    className: "st6",
    d: "M50.9,242.1l-0.3-0.5c-0.1,0.1-7.7,5.4-15.9,6.1c0.1,0.2,0.3,0.4,0.4,0.6 C43.3,247.4,50.8,242.1,50.9,242.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9524_",
    className: "st6",
    d: "M81.5,261.6l-0.3-0.5c-0.1,0.1-12.6,8.9-25.2,8.6c0.2,0.2,0.5,0.4,0.7,0.6 C69.2,270.2,81.4,261.7,81.5,261.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9523_",
    className: "st6",
    d: "M98.4,272.1c-0.1,0.1-13.1,9.2-26,8.6c0.4,0.2,0.8,0.4,1.2,0.6c12.6,0,25-8.7,25.1-8.8 L98.4,272.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9522_",
    className: "st6",
    d: "M43.4,258c0.2,0.2,0.3,0.4,0.5,0.5c10.7-1.1,20.4-8,20.5-8l-0.3-0.5 C63.9,250.2,54.1,257.1,43.4,258z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9506_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_795_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.6843,
    y1: 1056.5712,
    x2: 658.444,
    y2: 1056.5712,
    gradientTransform: "matrix(0.6545 -0.756 0.756 0.6545 -1123.5325 15.7201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9297A5"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9520_",
    className: "st9",
    d: "M68.5,178.6c0,0,31.4,18.3,47.2,54.2c15.8,35.9-4.4,43-4.4,43S92.4,286,76.6,250 C60.8,214.1,68.5,178.6,68.5,178.6z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9518_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9519_",
    className: "st6",
    d: "M111.5,276.2c0.2-0.1,0.2-0.2,0.2-0.4l-39-88.6c-0.1-0.2-0.2-0.2-0.4-0.2 c-0.2,0.1-0.2,0.2-0.2,0.4l39,88.6C111.2,276.2,111.4,276.3,111.5,276.2z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9517_",
    className: "st6",
    d: "M81.8,208.9c-0.1,0-8.4,0.2-15-3.3c0-0.2,0-0.5,0-0.7c6.5,3.6,14.9,3.4,15,3.4L81.8,208.9z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9516_",
    className: "st6",
    d: "M74.5,192.4c-0.1,0-3.4,0.1-7.6-0.8c0-0.2,0-0.4,0-0.6c4.1,0.8,7.4,0.8,7.5,0.8L74.5,192.4 z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9515_",
    className: "st6",
    d: "M85.6,217.7c-0.1,0-10.9,0.3-18.4-4.8c0-0.3,0-0.5-0.1-0.8c7.3,5.2,18.3,5,18.4,4.9 L85.6,217.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9514_",
    className: "st6",
    d: "M102.1,255.2c-0.2,0-15.8,0.4-26.3-7.1c-0.1-0.4-0.3-0.7-0.4-1.1 c10.3,7.9,26.5,7.5,26.7,7.5L102.1,255.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9513_",
    className: "st6",
    d: "M108.2,268.5l0,0.6c-0.2,0-13.9,0.3-24.3-5.8c-0.3-0.4-0.5-0.8-0.8-1.2 C93.4,268.9,108.1,268.5,108.2,268.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9512_",
    className: "st6",
    d: "M92.1,232.3c-0.2,0-13.1,0.3-22.9-5.5c-0.1-0.3-0.1-0.5-0.2-0.8c9.6,6,22.8,5.7,23,5.6 L92.1,232.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9511_",
    className: "st6",
    d: "M85.7,191.7c-2.4,5.9-6.7,10.3-6.7,10.4l-0.4-0.4c0.1-0.1,4.4-4.5,6.7-10.4 C85.4,191.4,85.5,191.6,85.7,191.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9510_",
    className: "st6",
    d: "M83.6,212.8l-0.4-0.4c0.1-0.1,6.5-6.8,8.4-14.8c0.2,0.2,0.3,0.3,0.5,0.5 C90.1,206.1,83.7,212.7,83.6,212.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9509_",
    className: "st6",
    d: "M98.3,246l-0.4-0.4c0.1-0.1,10.7-11.2,12.4-23.6c0.2,0.3,0.3,0.6,0.5,0.8 C108.7,235.2,98.4,245.9,98.3,246z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9508_",
    className: "st6",
    d: "M106.1,264.3c0.1-0.1,11.1-11.6,12.5-24.4c0.1,0.4,0.3,0.9,0.4,1.3 c-1.9,12.5-12.3,23.4-12.5,23.5L106.1,264.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9507_",
    className: "st6",
    d: "M100.6,207.7c0.2,0.2,0.3,0.4,0.5,0.6c-2.8,10.4-11,19-11.1,19.1l-0.4-0.4 C89.7,226.9,98,218.2,100.6,207.7z"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9585_",
    className: "st7",
    d: "M72.3,288.6c0,12.3,86.7,22.3,193.6,22.3s193.6-10,193.6-22.3c0-12.3-86.7-22.3-193.6-22.3 S72.3,276.2,72.3,288.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "feuilles2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9539_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9569_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_796_",
    gradientUnits: "userSpaceOnUse",
    x1: -550.3767,
    y1: 147.7245,
    x2: -578.2729,
    y2: 96.3837,
    gradientTransform: "matrix(-0.9724 -0.2332 -0.2332 0.9724 -96.4558 -10.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4137"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9583_",
    className: "st20",
    d: "M462.5,191.2c0,0-1.4,31.4-22.4,57.9C419,275.6,405.4,263,405.4,263s-15.3-10.4,5.8-36.9 C432.3,199.5,462.5,191.2,462.5,191.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9582_",
    className: "st6",
    d: "M405.2,263.3c0.1,0.1,0.3,0.1,0.4,0l52-65.4c0.1-0.1,0.1-0.3,0-0.4 c-0.1-0.1-0.3-0.1-0.4,0l-52,65.4C405.1,263,405.1,263.2,405.2,263.3z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9580_",
    className: "st6",
    d: "M444.6,213.5c0-0.1-3.5-6.3-3.5-12.8c0.2-0.1,0.3-0.2,0.5-0.3c-0.1,6.4,3.4,12.8,3.4,12.9 L444.6,213.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9579_",
    className: "st6",
    d: "M454.4,201.3c0-0.1-1.4-2.6-2.5-6.1c0.2-0.1,0.3-0.1,0.5-0.2c1,3.5,2.4,6,2.4,6 L454.4,201.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9578_",
    className: "st6",
    d: "M439.5,219.9c-0.1-0.1-4.6-8.2-3.7-16c0.2-0.1,0.4-0.2,0.6-0.4c-1,7.7,3.6,16,3.6,16.1 L439.5,219.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9577_",
    className: "st6",
    d: "M417.5,247.7c-0.1-0.1-6.6-11.9-5.2-22.9c0.2-0.3,0.4-0.5,0.6-0.8 c-1.9,11.1,4.9,23.3,5,23.4L417.5,247.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9576_",
    className: "st6",
    d: "M409.8,257.7l-0.4,0.3c-0.1-0.1-5.9-10.5-5.4-20.9c0.2-0.4,0.4-0.7,0.6-1.1 C403.5,246.5,409.7,257.6,409.8,257.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9575_",
    className: "st6",
    d: "M431,230.8c-0.1-0.1-5.5-9.9-5-19.7c0.2-0.1,0.4-0.3,0.5-0.4c-0.7,9.7,4.9,19.7,4.9,19.8 L431,230.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9574_",
    className: "st6",
    d: "M459.4,209.6c-5.5,0.5-10.6-0.9-10.6-1l0.1-0.5c0.1,0,5.2,1.5,10.6,0.9 C459.5,209.2,459.4,209.4,459.4,209.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9573_",
    className: "st6",
    d: "M442.5,216.5l0.1-0.5c0.1,0,7.8,2.3,14.7,0.5c-0.1,0.2-0.1,0.4-0.2,0.6 C450.2,218.7,442.6,216.5,442.5,216.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9572_",
    className: "st6",
    d: "M423,241l0.1-0.5c0.1,0,12.8,3.7,23-0.1c-0.1,0.2-0.3,0.5-0.4,0.7 C435.4,244.6,423.1,241.1,423,241z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9571_",
    className: "st6",
    d: "M412.1,254.3c0.2,0,13.3,3.8,23.6-0.3c-0.3,0.3-0.5,0.6-0.8,0.8c-10.3,3.6-22.8,0-23-0.1 L412.1,254.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9570_",
    className: "st6",
    d: "M453.1,227.4c-0.1,0.2-0.2,0.4-0.3,0.6c-9.1,2.1-18.9-0.8-19-0.8l0.1-0.5 C434.1,226.7,444.1,229.6,453.1,227.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9553_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_797_",
    gradientUnits: "userSpaceOnUse",
    x1: -508.8932,
    y1: 139.9092,
    x2: -556.0598,
    y2: 84.3574,
    gradientTransform: "matrix(-0.9724 -0.2332 -0.2332 0.9724 -96.4558 -10.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9297A5"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9567_",
    className: "st22",
    d: "M421.8,155.1c0,0-28.3,24.6-37.4,64c-9.1,39.4,12.7,42.7,12.7,42.7s21.1,6.6,30.2-32.8 C436.4,189.6,421.8,155.1,421.8,155.1z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9565_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9566_",
    className: "st6",
    d: "M397,262.2c-0.2,0-0.3-0.2-0.2-0.4l22.5-97.2c0-0.2,0.2-0.3,0.4-0.2 c0.2,0,0.3,0.2,0.2,0.4L397.3,262C397.3,262.2,397.1,262.3,397,262.2z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9564_",
    className: "st6",
    d: "M414.2,188.4c0.1,0,8.5-1.4,14.6-6.2c0-0.2-0.1-0.5-0.1-0.7c-5.9,4.9-14.5,6.3-14.6,6.3 L414.2,188.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9563_",
    className: "st6",
    d: "M418.4,170.2c0.1,0,3.5-0.6,7.5-2.2c-0.1-0.2-0.1-0.4-0.2-0.6c-4,1.6-7.4,2.2-7.5,2.2 L418.4,170.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9562_",
    className: "st6",
    d: "M412,197.9c0.1,0,11.1-1.8,17.7-8.4c0-0.3-0.1-0.5-0.1-0.8c-6.4,6.7-17.6,8.5-17.7,8.5 L412,197.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9561_",
    className: "st6",
    d: "M402.4,239.2c0.2,0,16.1-2.6,25.3-12.2c0.1-0.4,0.2-0.8,0.2-1.2 c-8.9,10-25.4,12.7-25.6,12.7L402.4,239.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9560_",
    className: "st6",
    d: "M398.8,253.8l0.1,0.6c0.2,0,14.2-2.3,23.5-10.5c0.2-0.4,0.4-0.9,0.6-1.4 C413.9,251.3,399,253.8,398.8,253.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9559_",
    className: "st6",
    d: "M408.1,214c0.2,0,13.4-2.2,22.1-9.9c0-0.3,0-0.6,0-0.8c-8.6,7.9-22.1,10.1-22.2,10.1 L408.1,214z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9558_",
    className: "st6",
    d: "M406.9,171.7c3.5,5.5,8.7,9.2,8.8,9.2l0.4-0.5c-0.1-0.1-5.3-3.8-8.8-9.2 C407.2,171.3,407.1,171.5,406.9,171.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9557_",
    className: "st6",
    d: "M413,192.6l0.4-0.5c-0.1-0.1-7.9-5.6-11.4-13.4c-0.1,0.2-0.3,0.4-0.4,0.6 C405.2,187.1,412.9,192.5,413,192.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9556_",
    className: "st6",
    d: "M404.6,229.1l0.4-0.5c-0.2-0.1-13-9.2-17.1-21.6c-0.1,0.3-0.2,0.6-0.3,0.9 C391.9,220.1,404.4,229,404.6,229.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9555_",
    className: "st6",
    d: "M400.2,249.1c-0.2-0.1-13.5-9.6-17.3-22.3c-0.1,0.5-0.1,0.9-0.2,1.4 c4.3,12.3,17,21.3,17.1,21.4L400.2,249.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9554_",
    className: "st6",
    d: "M394.9,190.8c-0.1,0.2-0.2,0.5-0.4,0.7c4.8,10,14.7,17.1,14.9,17.2l0.4-0.5 C409.6,208,399.5,200.8,394.9,190.8z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "nuage1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9492_",
    className: "st11",
    d: "M334.3,70.2c0-5.8-4.7-10.6-10.6-10.6c-4.1,0-7.6,2.3-9.4,5.7c-0.1,0-0.2-0.1-0.3-0.1 c-2.2-2.6-6-4.3-10.4-4.3c-2.9,0-5.6,0.8-7.7,2.1c-2.8-4.2-7.5-7-12.9-7c-6.7,0-12.4,4.2-14.5,10.1c-1.6-0.9-3.4-1.4-5.3-1.4 c-4.8,0-8.9,3-10.4,7.3c-1.3-0.6-2.7-1-4.2-1c-3.7,0-6.9,2.2-8.4,5.3h12h4.9h11.4h5.9H294h3.5h0.2h14.9h0.7h1.8h6.4h10.7h1.3 c0.1-0.5,0.1-0.9,0.1-1.4c0-0.3,0-0.7-0.1-1C334.1,72.8,334.3,71.6,334.3,70.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9420_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9491_",
    className: "st6",
    d: "M240.4,75.9l3.6-3.6C242.5,73.1,241.2,74.4,240.4,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9488_",
    className: "st6",
    d: "M247.1,71.2l-5.2,5.2h0.7l5.3-5.3C247.7,71.1,247.4,71.2,247.1,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9486_",
    className: "st6",
    d: "M249.9,71.2l-5.2,5.2h0.7l5.1-5.1C250.3,71.3,250.1,71.3,249.9,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9484_",
    className: "st6",
    d: "M252.1,71.9l-4.6,4.6h0.7l4.3-4.3C252.5,72,252.3,71.9,252.1,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9483_",
    className: "st6",
    d: "M259.1,65.6c-0.5,0.2-0.9,0.4-1.4,0.7l-4.2,4.2c-0.2,0.4-0.5,0.9-0.6,1.4L259.1,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9481_",
    className: "st6",
    d: "M261.9,64.9l-11.5,11.5h0.7l11.5-11.5C262.4,64.9,262.1,64.9,261.9,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9479_",
    className: "st6",
    d: "M264.7,65l-11.5,11.5h0.7l11.4-11.4C265.1,65,264.9,65,264.7,65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9477_",
    className: "st6",
    d: "M270,63.2l4.5-4.5C272.7,59.8,271.2,61.4,270,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9476_",
    className: "st6",
    d: "M266.9,65.5L256,76.4h0.7l10.7-10.7C267.3,65.7,267.1,65.6,266.9,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9474_",
    className: "st6",
    d: "M278.5,56.8l-19.6,19.6h0.7l19.9-19.9C279.2,56.6,278.8,56.7,278.5,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9472_",
    className: "st6",
    d: "M282,56.1l-20.3,20.3h0.7l20.3-20.3C282.5,56.1,282.2,56.1,282,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9470_",
    className: "st6",
    d: "M284.7,56.2l-20.2,20.2h0.7l20.1-20.1C285.1,56.3,284.9,56.2,284.7,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9468_",
    className: "st6",
    d: "M287.1,56.7l-19.8,19.8h0.7l19.6-19.6C287.5,56.8,287.3,56.7,287.1,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9466_",
    className: "st6",
    d: "M289.2,57.4l-19,19h0.7l18.8-18.8C289.5,57.5,289.3,57.5,289.2,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9464_",
    className: "st6",
    d: "M291,58.4L273,76.4h0.7l17.8-17.8C291.3,58.5,291.2,58.4,291,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9462_",
    className: "st6",
    d: "M292.7,59.5l-16.9,16.9h0.7l16.6-16.6C293,59.7,292.8,59.6,292.7,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9460_",
    className: "st6",
    d: "M294.2,60.9l-15.6,15.6h0.7l15.2-15.2C294.4,61.1,294.3,61,294.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9458_",
    className: "st6",
    d: "M295.5,62.4l-14,14h0.7l13.6-13.6C295.7,62.7,295.6,62.5,295.5,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9456_",
    className: "st6",
    d: "M298.9,61.8l-14.7,14.7h0.7l14.9-14.9C299.6,61.6,299.2,61.7,298.9,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9454_",
    className: "st6",
    d: "M302.4,61.1l-15.3,15.3h0.7l15.4-15.4C302.9,61.1,302.7,61.1,302.4,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9452_",
    className: "st6",
    d: "M305.2,61.1l-15.3,15.3h0.7l15.2-15.2C305.6,61.2,305.4,61.1,305.2,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9449_",
    className: "st6",
    d: "M307.6,61.5l-14.9,14.9h0.7l14.7-14.7C308,61.6,307.8,61.6,307.6,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9447_",
    className: "st6",
    d: "M309.7,62.2l-14.2,14.2h0.7l14-14C310.1,62.4,309.9,62.3,309.7,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9445_",
    className: "st6",
    d: "M311.6,63.2l-13.2,13.2h0.7L312,63.5C311.9,63.4,311.7,63.3,311.6,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9443_",
    className: "st6",
    d: "M313.2,64.4l-12,12h0.7l11.7-11.7C313.4,64.7,313.3,64.5,313.2,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9441_",
    className: "st6",
    d: "M320.1,60.4L304,76.4h0.7L321.1,60C320.8,60.1,320.4,60.2,320.1,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9439_",
    className: "st6",
    d: "M323.8,59.7c-0.1,0-0.1,0-0.2,0l-16.7,16.7h0.7l16.7-16.7 C324.1,59.7,323.9,59.7,323.8,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9437_",
    className: "st6",
    d: "M326.1,60l-16.5,16.5h0.7l16.3-16.3C326.5,60.1,326.3,60,326.1,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9435_",
    className: "st6",
    d: "M328.2,60.7l-15.7,15.7h0.2h0.5l15.5-15.5C328.5,60.8,328.4,60.8,328.2,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9433_",
    className: "st6",
    d: "M330,61.7l-14.7,14.7h0.7L330.4,62C330.3,61.9,330.1,61.8,330,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9431_",
    className: "st6",
    d: "M331.5,63.1l-13.4,13.4h0.7l13-13C331.7,63.3,331.6,63.2,331.5,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9429_",
    className: "st6",
    d: "M332.7,64.7l-11.8,11.8h0.7c0,0,11.3-11.3,11.3-11.3C332.9,65,332.8,64.8,332.7,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9427_",
    className: "st6",
    d: "M333.6,66.6l-9.9,9.9h0.7l9.3-9.3C333.8,66.9,333.7,66.7,333.6,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9425_",
    className: "st6",
    d: "M334.2,68.8l-7.6,7.6h0.7l7-7C334.3,69.2,334.2,69,334.2,68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9423_",
    className: "st6",
    d: "M334.2,71.6l-4.8,4.8h0.7l3.9-3.9C334.1,72.2,334.2,71.9,334.2,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9421_",
    className: "st6",
    d: "M333.7,75c0,0-1.4,1.4-1.4,1.4h0.1h0.7l0.7-0.7C333.7,75.5,333.7,75.3,333.7,75z"
  })))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1953_",
    className: "st11",
    d: "M186.6,58.7c-8.5-7.9-19.4-12.3-31-12.5c-0.3-0.1-0.6-0.1-0.9,0c0,0-0.1,0-0.1,0 c-11.7,0.1-22.7,4.5-31.3,12.5c-9.3,8.7-14.7,21-14.7,33.9v0c0,12.9,5.2,24.8,14.5,33.7c0.1,0.1,0.1,0.2,0.2,0.2 c0.1,0.1,0.1,0.1,0.2,0.1c8.5,7.8,19.6,12.2,31.1,12.3h0.5c11.7,0,22.8-4.5,31.4-12.4c9.5-8.9,14.8-20.9,14.8-33.9v0 C201.3,79.7,196,67.3,186.6,58.7z M198.5,91h-18.7c-0.2-7.7-1.9-15.1-5.2-22.1c4-1.9,7.7-4.3,11.1-7.3C193.5,69.4,198,80,198.5,91z  M153.5,70.3c-4.2-0.2-9-1.3-13.7-3.1c3.4-6.2,8.1-11.9,13.7-16.5V70.3z M156.4,50.4c5.8,4.8,10.7,10.6,14.1,17.1 c-4.5,1.7-9.3,2.7-14.1,2.8V50.4z M173.2,66.3c-3.4-6.4-8.1-12.2-13.7-17c8.8,0.9,17.2,4.5,23.9,10.4 C180.4,62.4,176.9,64.6,173.2,66.3z M137.1,66.1c-4-1.8-7.7-4-10.5-6.4c6.8-5.9,15.2-9.6,24.2-10.4C145.2,54,140.5,59.8,137.1,66.1 z M138.5,69.8c5.1,2,10.5,3.2,15.1,3.4V91h-20.3C133.5,83.6,135.2,76.5,138.5,69.8z M153.5,93.9v18c-5.2,0.2-10.3,1.2-15.1,3 c-3.2-6.7-4.9-13.7-5.1-21.1H153.5z M156.4,114.9c4.8,0.2,9.4,1.1,13.8,2.8c-3.4,6.2-8.2,11.9-13.8,16.6V114.9z M153.5,134.2 c-5.7-4.7-10.4-10.4-13.8-16.6c4.4-1.7,9-2.6,13.8-2.7V134.2z M137,118.7c3.4,6.4,8.2,12.2,13.9,17.1c-9-0.9-17.5-4.5-24.4-10.5 C129.7,122.6,133.2,120.4,137,118.7z M173,118.8c3.8,1.7,7.3,3.9,10.4,6.6c-6.9,6-15.4,9.6-24.4,10.4 C164.7,131,169.5,125.2,173,118.8z M171.6,115.1c-4.9-1.9-10-2.9-15.2-3.1v-18h20.4C176.6,101.3,174.8,108.4,171.6,115.1z  M156.4,91V73.2c5.3-0.2,10.5-1.2,15.4-3.1c3.1,6.6,4.8,13.7,5,21H156.4z M124.4,61.7c3.1,2.7,7,5,11.4,7 c-3.4,7.1-5.2,14.6-5.4,22.4h-18.8C111.9,80,116.6,69.4,124.4,61.7z M111.6,93.9h18.8c0.2,7.7,2,15.2,5.3,22.2 c-4.1,1.9-7.9,4.3-11.3,7.3C116.4,115.5,111.9,105.1,111.6,93.9z M185.6,123.4c-3.4-3-7.2-5.4-11.3-7.3c3.4-7,5.2-14.5,5.4-22.3 h18.7C198.1,105.2,193.6,115.5,185.6,123.4z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1965_",
    className: "st33",
    points: "124.5,270.6 113.5,270.8 119.9,283 428.7,283 435.2,270.8 433.6,270.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1964_",
    d: "M312,271.3c-2.2,3.8-5.2,6-8.5,6h-62.2c-3.3,0-6.3-2.2-8.5-6H312z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1963_",
    className: "st34",
    d: "M160.5,255.3h227.5V104.9c0-2.5-2-4.5-4.5-4.5H165c-2.5,0-4.5,2-4.5,4.5V255.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1962_",
    x: 166.8,
    y: 107.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 548.6046 351.544)",
    className: "st6",
    width: 215,
    height: 136.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1961_",
    x: 166.8,
    y: 107.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 548.6046 351.544)",
    className: "st6",
    width: 215,
    height: 136.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1960_",
    x: 166.8,
    y: 107.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 548.6046 351.544)",
    className: "st35",
    width: 215,
    height: 136.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1959_",
    x: 166.8,
    y: 107.4,
    className: "st36",
    width: 215,
    height: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1958_",
    d: "M272,103.9c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3c0,1.3-1,2.3-2.3,2.3C273,106.2,272,105.2,272,103.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1957_",
    className: "st34",
    d: "M116,271.1h316.6c2.9,0,4.3-1,2.3-1.6l-46.6-14.4h-228l-46.6,14.4 C111.7,270.1,113.1,271.1,116,271.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1956_",
    className: "st36",
    points: "209.1,268.6 339.5,268.6 329,264.6 219.2,264.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1955_",
    className: "st36",
    points: "409.4,262.6 139.2,262.6 160.5,255.8 388.1,255.8  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1908_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1952_",
    x: 166.8,
    y: 113.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 548.3862 363.3235)",
    className: "st7",
    width: 214.7,
    height: 135.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1948_",
    className: "st11",
    d: "M178.7,146.8c-0.1,0.1-0.5,3.2,1,4.5c0,0,0.1,0.1,0.1,0.1c0.2,0.1,0.4,0.2,0.6,0.4 c0,0,0,0,0,0c0.9,0.5,2.1,0.9,3.3,1.2c0.7,0.6,1.7,1.2,1.9,1.2c0.2,0,2.3,0,4.7,0c1.2,1.6,3.1,2.6,5.3,2.6c2.2,0,4.1-1,5.3-2.6 c8.3,0,39,0,48.2,0c1.2,1.6,3.1,2.6,5.3,2.6c2,0,3.9-0.9,5.1-2.3c1.7,0.1,3,0.1,3.1,0.1c3.5,0,4.9-1.2,5-1.2 c3.9-1.5,1.5-1.9,1.5-1.9s0-0.2,0-0.4c0-0.2-0.4-0.4-0.4-0.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2 c0-0.4,0-1.1,0.2-1.7c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.2-1,0.5-2.4,0.1-2.8 c-0.4-0.5-9.6-7.2-26.4-8c-0.2,0-0.5,0-0.7,0c0,0,0,0,0,0c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4,0-0.5,0 c-0.3,0-0.5,0-0.8,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0 c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c-3-1.5-8.2-3.9-11.4-4.5c-0.4-0.1-0.8-0.1-1.2,0 c-0.6,0.1-0.8,0.1-1,0.2c-0.2,0.1-1.1,1.2-1,1.6c0,0.2,2.8,1.4,6,2.8c0,0,0,0.1,0,0.1l-0.4,1.5c-2.8-0.2-6.1-0.5-9.3-0.7 c-0.4-1.4-0.9-2.9-1.5-3.2c-1.1-0.5-2.1,0.5-2.4,0.9c-0.1,0.1-0.2,1-0.3,2c-1.6-0.1-3.2-0.2-4.5-0.3c-2.6-0.2-4.8-0.3-6.8-0.4 c0-0.4-0.2-2.5-2.6-2.1c-2.6,0.4-4,1-4.1,1.6c0,0.1,0,0.1,0,0.2c-1.1,0-2,0-2.8,0.1c-2.9,0.2-8.3,1.3-8.3,1.3 c-0.8,0.2-3.6-0.7-4.8-0.7c-1.3-0.1-1.7,0.8-1.5,1.3c0.1,0.2,0.2,0.4,0.2,0.6c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.4,0,0.6c0,0,0,0,0,0 c-0.5,0.4-0.8,3.6-0.1,3.7c0,0,0.1,0,0.1,0c-0.2,0.2-1.3,0.8-1.3,1.1c0,0.2,0,0.6,0,1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1 C178.8,146.6,178.8,146.7,178.7,146.8z M229.4,138l0.3-1.2c0.4,0.2,0.9,0.4,1.3,0.6c-0.3-0.1-0.5,0.1-0.6,0.3l-0.1,0.4 c-0.2,0-0.4,0-0.6,0L229.4,138z M228.8,136.4c0.3,0.1,0.6,0.3,0.9,0.4C229.4,136.7,229.1,136.5,228.8,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1947_",
    className: "st11",
    d: "M282.2,148.1c-0.2-0.5-0.2-0.9-0.2-1.4c0-1,1.2-2.7,1.2-2.8c0,0,0,0,0,0c0,0,0,0,0,0 c0.1-0.3,0.8-2.1,1-2.5c0.2-0.4,0-0.8,0.1-1.2c0.1-0.4,0.8-1.4,1-1.6c-0.8-0.5,0.2-0.6,0.9-0.6c0.7,0,6.5-0.6,7.3-0.9 c1.8-1,9.9-3.8,11.8-4.2c1.8-0.4,13.8-2.1,22.3-1c8.6,1,14.5,6.6,16.1,6.7c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0 c2.7,0.2,11.2,0.9,14.7,1.2c3.9,0.4,6.1,1.6,7.7,2.5c1.7,1.2,1.8,4.2,1.8,4.9c0.6,2,0.5,3.6,0.2,4.8c-0.5,0.3-1.1,0.5-1.7,0.6 c-0.8,0.6-1.8,1.2-2.6,1.2c-0.2,0-1.2,0-2.9,0c-1.2,1.7-3.2,2.8-5.5,2.8c-2.3,0-4.3-1.1-5.5-2.9c-12.8-0.1-31.5-0.3-43.6-0.4 c-1.1,2-3.3,3.3-5.8,3.3c-2.6,0-4.8-1.4-5.9-3.5C294,153.2,281.1,151.6,282.2,148.1L282.2,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1946_",
    className: "st11",
    d: "M176.5,218.1c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.2-0.4,0.7-0.6,1.1-0.6c0,0,0,0,0.1,0 c0.3,0,0.6,0,0.9,0.1c0.8,0.2,1.5,0.5,1.6,0.5c0.2,0.1,1,0.8,1.2,1.5c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0c0.2,0.3,0.7,0.3,0.9,0.3 c0.9-2.6,2.9-7.6,4.6-8.4c2.3-1.1,12.8-1,13.1-1c0.2,0,10.7-0.1,13.1,1c1.7,0.8,3.7,5.8,4.6,8.4c0.2,0,0.8,0,1-0.3c0,0,0,0,0,0 c0-0.1,0.1-0.1,0.1-0.2c0.2-0.7,1-1.4,1.2-1.5c0.1,0,0.8-0.4,1.6-0.5c0.3-0.1,0.6-0.1,0.9-0.1c0,0,0,0,0.1,0 c0.5,0,0.9,0.2,1.1,0.6c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.1-0.6,0.2c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0.1,0.2,0.1,0.3,0.1,0.3s0.4,0,0.6,0.3 c0.2,0.2,0.4,0.5,1.1,0.8c0.7,0.3,2.2,0.8,2.2,1.1c0.1,0.2,0.1,0.6,0.3,0.7c0.2,0.2,1,0.3,1,1.5c0,0.5-0.1,2.8-0.2,5.3 c0.3,0.2,0.4,0.5,0.4,0.8v9.3c0,0.5-0.5,1-1,1h-0.6h-0.9h-1.5h-0.4h-1.7H217h-0.3h-0.5h-0.6c-0.6,0-1-0.4-1-1v-0.3h-28.3v0.3 c0,0.5-0.5,1-1,1h-0.6H184h-0.3h-0.9h-1.7h-0.4h-1.5h-0.9h-0.6c-0.6,0-1-0.4-1-1v-9.3c0-0.4,0.2-0.7,0.5-0.9 c-0.1-2.4-0.2-4.7-0.2-5.3c0-1.2,0.8-1.3,1-1.5c0.2-0.2,0.2-0.5,0.3-0.7c0.1-0.2,1.5-0.8,2.2-1.1c0.7-0.3,0.9-0.6,1.1-0.8 c0.2-0.2,0.5-0.3,0.6-0.3c0,0-0.1,0-0.1,0s0-0.1,0.1-0.3c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0 c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0 c-0.2-0.1-0.4-0.1-0.6-0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1 c0,0,0,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0-0.1-0.1c0,0,0,0,0-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.2 c0,0,0-0.1,0-0.1C176.5,218.2,176.5,218.1,176.5,218.1L176.5,218.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1945_",
    className: "st11",
    d: "M229.7,231.6c0.4-0.3,0.6-1.1,0.7-2c0-0.2,0.2-0.3,0.5-0.3h0.4l-0.9,0 c-0.1,0-0.2-0.1-0.2-0.2v-2.2c0-0.1,0.1-0.2,0.2-0.2h0.7c-0.3,0-0.5-0.2-0.5-0.4c0-0.2,0-0.3,0-0.5c0-0.2,0.2-0.4,0.5-0.4h-0.7 c-0.1,0-0.2-0.1-0.2-0.2v-2.2c0-0.1,0.1-0.2,0.2-0.2h0.8c-0.3,0-0.6-0.2-0.5-0.5c0,0,0,0,0,0c0.1-0.2,0.7-0.6,1.4-1.2 c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0.7-2.3,2.3-7.7,2.8-8.3c0.6-0.7,1.9-1.3,1.9-1.3c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0 c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c8-0.6,21.9,1,23.8,1.6 c0.4,0.1,0.9,0.3,1.5,0.6c2.3,0.6,7.6,2.8,16,10.1c0.8,0,1.4,0.5,1.7,0.9c1.1,0.4,6,2.9,4.5,7.1c0.6,0.3,4.1,4,2.1,7.8h-1 c-0.1,0.3-0.4,0.5-0.8,0.5h-3.6c-0.2,0.5-0.5,1-1,1.4c-2.1,2.2-5.7,2.4-8,0.4c-0.5-0.5-0.9-1-1.3-1.5H245 c-0.2,0.4-0.5,0.8-0.8,1.1c-2.1,2.2-5.7,2.4-8,0.4c-0.6-0.5-1.1-1.2-1.4-1.8h-3.4c-0.5,0-0.9-0.2-1-0.5c-0.5-0.1-0.9-0.4-1-0.8 C229.1,235.5,228.7,232.5,229.7,231.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1944_",
    x: 166.8,
    y: 247,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 548.3862 496.5072)",
    className: "st11",
    width: 214.7,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1943_",
    x: 312.9,
    y: 180,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 562.3877 -199.0642)",
    className: "st11",
    width: 135.6,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1942_",
    x: 100.3,
    y: 180.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 349.7684 13.5551)",
    className: "st11",
    width: 135.6,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1941_",
    x: 286.4,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 535.8934 -172.5699)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1940_",
    x: 259.8,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 509.2139 -145.8904)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1939_",
    x: 233.1,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 482.5343 -119.2109)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1938_",
    x: 206.4,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 455.8548 -92.5313)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1937_",
    x: 179.7,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 429.1753 -65.8518)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1936_",
    x: 153,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 402.4958 -39.1723)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1935_",
    x: 126.4,
    y: 181,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 375.8163 -12.4928)",
    className: "st11",
    width: 135.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1934_",
    x: 166.8,
    y: 160.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 548.0076 339.1573)",
    className: "st11",
    width: 214.3,
    height: 18.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1933_",
    x: 300.4,
    y: 186.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 655.0994 433.1318)",
    className: "st11",
    width: 54.3,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1932_",
    x: 295.9,
    y: 217.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 545.3254 -109.7788)",
    className: "st7",
    width: 63.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1929_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1931_",
    className: "st7",
    d: "M331.7,219.3h0.9c0.9,0,1.7-0.8,1.7-1.7v-2.2c0-0.9-0.8-1.7-1.7-1.7h-0.9 c-0.9,0-1.7,0.8-1.7,1.7v2.2C330,218.6,330.8,219.3,331.7,219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1930_",
    className: "st7",
    d: "M322.5,219.3h0.9c0.9,0,1.7-0.8,1.7-1.7v-2.2c0-0.9-0.8-1.7-1.7-1.7h-0.9 c-0.9,0-1.7,0.8-1.7,1.7v2.2C320.8,218.6,321.6,219.3,322.5,219.3z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9622_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9662_",
    className: "st37",
    d: "M119.2,284.9c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.8-0.6-0.7-1.1l3.5-14.4 c0.1-0.5,0.6-0.8,1.1-0.7c0.5,0.1,0.8,0.6,0.7,1.1l-3.5,14.4C120,284.7,119.6,284.9,119.2,284.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9661_",
    className: "st37",
    d: "M99.4,284.9c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.8-0.6-0.7-1.1l5.1-20.8 c0.1-0.5,0.6-0.8,1.1-0.7c0.5,0.1,0.8,0.6,0.7,1.1l-5.1,20.8C100.2,284.7,99.8,284.9,99.4,284.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9660_",
    className: "st17",
    d: "M107.3,209.7c35.1,0,28.4,36.1,39.5,35.5c11.1-0.6,16.2,25.5-24.1,25.5 S75,209.7,107.3,209.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9623_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9659_",
    className: "st16",
    d: "M157,277.1c0,0-0.1,6.2,0,6.3c0,0.1-0.5,0.9-0.5,0.9l-2,0.4l-1.8-0.8c0,0,0.2-5.8,0-6.7 C152.5,276.2,157,277.1,157,277.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9658_",
    className: "st37",
    d: "M152.7,283.8c0,0,2.3,0.8,4.2-0.5c0,0,7.5,2.8,7.3,5c0,0,0.3,0.6-2.9,0.5 c-3.3-0.1-8.3-0.3-8.5-0.4C152.7,288.3,152.1,288.7,152.7,283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9657_",
    className: "st16",
    d: "M138,277.1c0,0-0.1,6.2,0,6.3c0,0.1-0.5,0.9-0.5,0.9l-2,0.4l-1.8-0.8c0,0,0.2-5.8,0-6.7 C133.6,276.2,138,277.1,138,277.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9656_",
    className: "st37",
    d: "M133.8,283.8c0,0,2.3,0.8,4.2-0.5c0,0,7.5,2.8,7.3,5c0,0,0.3,0.6-2.9,0.5 c-3.3-0.1-8.3-0.3-8.5-0.4C133.7,288.3,133.1,288.7,133.8,283.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9641_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9643_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9655_",
    className: "st38",
    d: "M119.9,204.7c0,0,0.6-0.7,1-0.4c0.9,0.9-0.2,1.8-0.9,2L119.9,204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9654_",
    className: "st16",
    d: "M120.4,201.9L120.4,201.9c0-0.1,0-0.2,0-0.2c0.4-3.6-2.3-6.8-6-6.9c-3-0.1-5.8,2-6.4,5 c-0.2,1.1-0.1,2.2,0.2,3.2c0.4,1.5,0.8,2.8,1.2,3.9c0.7,1.8,0.8,3.8,0.2,5.7l-0.4,1.5c3.6,2.5,5.6,0.8,5.6,0.8l0.4-2.7 c0-0.4,0.4-0.6,0.7-0.6c0,0,0,0,0,0C120.7,211.6,120.2,204,120.4,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9653_",
    className: "st37",
    d: "M113.6,204.4c0-0.3-0.2-0.6-0.5-0.6c-0.3,0-0.6,0.2-0.6,0.5c0,0.3,0.2,0.6,0.5,0.6 C113.3,205,113.6,204.8,113.6,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9652_",
    className: "st37",
    d: "M118.9,204c0-0.3-0.2-0.6-0.5-0.6c-0.3,0-0.6,0.2-0.6,0.5c0,0.3,0.2,0.6,0.5,0.6 C118.6,204.5,118.9,204.3,118.9,204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9651_",
    className: "st37",
    d: "M111.7,203.3c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.1-0.5c0.3-0.5,1.3-1.1,2.5-0.3 c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1c-1-0.7-1.6,0.1-1.6,0.1C111.9,203.3,111.8,203.3,111.7,203.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9650_",
    className: "st37",
    d: "M117.2,203c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.1-0.5c0.3-0.5,1.3-1.1,2.5-0.3 c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1c-1-0.7-1.6,0.1-1.6,0.1C117.4,203,117.3,203,117.2,203z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9649_",
    className: "st37",
    points: "107.4,200.6 108.6,205 109.8,204.9 111.1,199.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9648_",
    className: "st16",
    d: "M110,204.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.4-0.2-1.1-0.5-1.7,0c-0.8,0.7,0.5,2.9,2.1,2 C109.9,206.3,110.4,205.9,110,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9647_",
    className: "st38",
    d: "M116.4,206.9c-0.6,0.2-1-0.1-1.1-0.1c0,0-0.1-0.1,0-0.1c0,0,0.1-0.1,0.1,0 c0,0,0.5,0.4,1.1,0c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.6-0.8-0.6-1.9c0-0.1,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.1,0.1c0,1,0.4,1.5,0.6,1.8c0.1,0.2,0.2,0.3,0.2,0.5c0,0.1-0.1,0.2-0.2,0.3C116.6,206.8,116.5,206.8,116.4,206.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9645_",
    className: "st37",
    d: "M119.7,199.4c0,0,0.8,0.7,0.6,4.5c0,0,0.8-4.2,0.4-4.7 C120.2,198.7,119.7,199.4,119.7,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9644_",
    className: "st37",
    d: "M116.8,208.9c0.3-0.1,0.6-0.2,0.8-0.5c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0 c-1.2,1.2-2.7-0.1-2.8-0.2c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1C114.6,208.3,115.7,209.2,116.8,208.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9642_",
    className: "st37",
    d: "M107.1,199.2c0.1-0.9,0.5-1.8,1-2.6c-0.4,0.1-0.9,0.1-1.3-0.2c-0.4-0.3-0.3-1,0.1-1 c0.3-0.1,0.5,0.1,0.7,0.2c0.6,0.1,1-0.5,1.2-1.1c0.2-0.6,0.3-1.2,0.9-1.5c0.2-0.1,0.4-0.1,0.5-0.1c0.1,0.7,0,1.4-0.3,2 c0.7-0.8,1.6-1.6,2.5-2.1c0.8-0.4,1.7-0.7,2.5-0.4c0.2,0.7-0.9,1-1.1,1.6c1.5-0.4,3-0.5,4.5-0.4c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.2,0.6,0.5,0.7,0.9c0,0.5-0.4,1-0.9,0.9c0.7,0.3,1.5,0.7,2.1,1.2c0.6,0.5,1.1,1.2,1.2,2.1c-0.5,0-1.1-0.1-1.6-0.4 c0.3,0.3,0.6,0.8,0.4,1.2c-0.1,0.3-0.5,0.5-0.8,0.5c-0.3,0-0.7-0.1-1-0.2c-1.6-0.5-3.2-1-4.8-1.5c0.6,0.7,1.1,1.5,1.3,2.4 c-1.4-0.2-2.8-0.8-3.9-1.7c-0.1,0.7-0.4,1.3-0.7,2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.2-0.6-0.3-0.9-0.5c-0.4-0.3-0.9-0.2-1.3,0.1 c-0.7,0.4-1.2,0.9-1.7,0.1C107.2,200.6,107.1,199.9,107.1,199.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9640_",
    className: "st6",
    d: "M149.1,246.3c0,0,7.3,0.6,9.6,9.9c1.4,5.4,0.8,22.9,0.8,22.9l-9.4,1.5 c0,0,0.8-19.6-6.5-25.6c0,0,1.5,4-3.9,26.6h-7l-2.3-23.2c0,0-16.5,0.5-21.4-3.6c-4.9-4.1-5.4-9-5.4-9l23.3-3.5L149.1,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9639_",
    className: "st37",
    d: "M107.3,214.8c0,0,0.5-3.5,1.2-3.3c0.7,0.2,7.2,1.4,7.9,1.2c0.6-0.1,0,3,0,3 s7.3,0.7,9.1,3.8c1.8,3.1,6.1,14.9,7.6,15.9c1.6,1,4.6,3.8,4.6,3.8l-12.6,7.1l-12-0.6c0,0-8.7,5.2-15.4,1.1 c-6.8-4-5.6-25.3,0.8-29C104.9,214.1,107.3,214.8,107.3,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9638_",
    className: "st37",
    d: "M128.6,243C128.6,243,128.6,243,128.6,243c-3.7-1.6-5.6-17.4-5.7-18c0-0.1,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.1,0.1c0,0.2,2,16.3,5.6,17.9C128.7,242.9,128.7,242.9,128.6,243C128.6,243,128.6,243,128.6,243z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9637_",
    className: "st37",
    d: "M113.1,245.8C113.1,245.8,113,245.8,113.1,245.8c-0.1-0.1-0.1-0.2,0-0.2l2.6-1.2l-0.4-4.6 c-0.8-0.2-8.2-1.6-11.8-2c0,0-0.1,0-0.1-0.1c0-0.4-0.1-8.7,0.4-9.9c0,0,0.1-0.1,0.1,0c0,0,0.1,0.1,0,0.1 c-0.5,1.1-0.4,8.9-0.4,9.8c3.8,0.4,11.7,2,11.8,2c0,0,0.1,0,0.1,0.1l0.4,4.7c0,0,0,0.1-0.1,0.1L113.1,245.8 C113.1,245.8,113.1,245.8,113.1,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9636_",
    className: "st37",
    d: "M143.6,255C143.6,255,143.5,255,143.6,255c-0.1-0.2-1.8-8.2-14.9-9.2 c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0.1-0.1c7,0.5,10.7,3,12.6,5c2.1,2.2,2.5,4.2,2.5,4.3C143.7,254.9,143.7,255,143.6,255 C143.6,255,143.6,255,143.6,255z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9628_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9630_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9635_",
    className: "st16",
    d: "M117.9,240.4c0,0,0.2,0,0.5,0c1.5,0,6,0.2,6.5,0.4c0.6,0.2-1.3,4.1-1.3,4.1 s-5.4,0.3-7.1-0.9C114.8,243,117.9,240.4,117.9,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9634_",
    className: "st16",
    d: "M122.9,245c0,0,3,1.4,3.3,1.1c0.3-0.3-2.4-1.8-2.4-1.8L122.9,245z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9633_",
    className: "st16",
    d: "M123.8,244c0,0,4.5,1.8,4.8,1.2c0.3-0.6-4.6-2.2-4.6-2.2L123.8,244z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9632_",
    className: "st16",
    d: "M124.4,243c0,0,4.6,1.4,4.9,0.8c0.3-0.6-4.8-1.8-4.8-1.8L124.4,243z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9631_",
    className: "st16",
    d: "M124.6,241.8c0,0,4.3,1.4,4.6,0.8c0.3-0.6-4.5-1.8-4.5-1.8L124.6,241.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9629_",
    className: "st16",
    points: "118.9,240.6 115.5,240.2 115.9,244 117.6,244.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9624_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9627_",
    className: "st12",
    points: "157.3,228.7 132.5,228.7 124.7,246.8 149.5,246.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_9626_",
    x: 113,
    y: 245.7,
    transform: "matrix(1 1.398081e-03 -1.398081e-03 1 0.3444 -0.1693)",
    className: "st12",
    width: 16.6,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9625_",
    className: "st6",
    d: "M142.4,237.5c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1 C142.9,238.6,142.4,238.1,142.4,237.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3499_",
    className: "st16",
    points: "315.3,200.3 320.8,199.5 317.6,196.5 314.7,195.6 313.1,197.2  "
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3471_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3505_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3537_",
    className: "st12",
    d: "M363.4,163.8c0.7,1.9,0.5,4.1,1.2,6c0.7,1.9,2.2,3.3,3.7,4.5c1.2,0.9,2.5,1.7,3.1,3 c1.4,2.9-1,6.5,0.2,9.5c0.6,1.4,1.9,2.4,2.1,3.9c0.1,1.1-0.5,2.3-1.4,3c-0.9,0.7-2,1-3.1,1.2c-1,0.1-1.9,0.1-2.9,0 c-1.1-0.2-2.1-0.5-3.2-0.7c-2.2-0.4-4.5-0.3-6.7,0.3c-1.7,0.5-3.3,1.2-5,1.2c-1.1,0-2.2-0.3-3.3-0.7c-1.2-0.4-2.3-0.9-3.2-1.8 c-1.3-1.2-2-2.9-2.5-4.6c-0.4-1.7-0.6-3.5-1-5.2c-0.5-2.2-1.5-4.3-2.7-6.2c-0.5-0.8-1.1-1.6-1.4-2.5c-0.2-0.6-0.2-1.3-0.2-1.9 c0.2-2.8,1.9-5.4,4.4-6.8c0.6-0.3,1.3-0.6,1.8-1c0.6-0.4,1-1.1,1.4-1.6c0.8-1.1,1.6-2.2,2.4-3.2c0.4-0.5,0.9-1.1,1.5-1.4 c0.7-0.4,1.5-0.6,2.3-0.7C355.2,157.5,361.7,159.4,363.4,163.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3534_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3536_",
    className: "st16",
    d: "M341.7,290.2c0,0,0.9,8.5-0.9,9.4c-3.1,1.7-8.9,3.4-8.4,4.9c0.5,1.5,14.3,1.5,14.7,0.2 c0.4-1.4-1.2-5.5,0.5-13.6L341.7,290.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3535_",
    className: "st37",
    d: "M346.9,301.6c0.1,1.5,0.3,2.6,0.1,3c-0.4,1.4-14.2,1.3-14.7-0.2 c-0.4-1.1,2.7-2.4,5.6-3.6C338.7,302,340.1,303.8,346.9,301.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3531_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3533_",
    className: "st16",
    d: "M367.6,289.9c0,0,2.3,8.2,0.7,9.4c-2.8,2.2-8.2,4.9-7.5,6.2c0.7,1.4,14.4-0.9,14.5-2.3 c0.1-1.4-2.1-5.2-1.9-13.5L367.6,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3532_",
    className: "st37",
    d: "M374.7,300.3c0.4,1.5,0.7,2.5,0.7,3c-0.1,1.4-13.8,3.7-14.5,2.3c-0.5-1,2.3-2.8,4.9-4.5 C366.6,302.1,368.4,303.6,374.7,300.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3530_",
    className: "st16",
    d: "M336.4,193.3c0,0-2.9,3.9-5.3,3.9c-2.4,0-15.9-8.4-15.9-8.4l-1,3.5 c0,0,11.1,12.8,17.4,12.9c6.3,0.1,11-6.9,10.9-7.3c-0.1-0.4-4.1-4.6-4.1-4.6H336.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3529_",
    className: "st6",
    d: "M343.3,215.2c0,0-3.8,4.5-5.4,9.9c-1.7,5.3,2.8,68.4,2.8,68.4h7.5c0,0,4-56.1,4-56.6 c0-2,14.8,56.6,14.8,56.6h7.5c0,0-4.1-68.6-13.5-78.2l-8.8,0.5L343.3,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3528_",
    className: "st37",
    d: "M343.3,212.9v2.4c0,0,4.5,4.4,17.6,0l0-2.4l-11.5-0.7L343.3,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3527_",
    className: "st34",
    d: "M347.7,184.4c0,0-4.7-0.2-7,1.5c-1.7,1.2-5.4,7.8-5.4,7.8l4.3,3.6c0,0-1,4,3,6l0.7,9.6 c0,0,7.5,4.4,17.7,0c0,0,1.9-18,3.7-16.4c1.8,1.6,2.9,3,2.9,3l6.8-6.7c0,0-7.4-7.4-9.8-8.6c-5.7-2.7-10.4-0.1-10.4-0.1 L347.7,184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3526_",
    className: "st16",
    d: "M368.2,198.8c0,0,3.9,4.6,3.5,5.9c-0.5,1.3-7.4,11.7-8.3,13.7c-0.9,2-0.7,3.2-0.7,3.2 l3.5,1.7c0,0,0.2-2.8,1-3.6c0.8-0.8,12.5-12.9,12.2-16.7c-0.3-3.8-5.6-9.6-5.6-9.6L368.2,198.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3525_",
    className: "st16",
    d: "M345.7,169.7c0,0-0.5-1-1-0.7c-1.4,0.8-0.2,2.3,0.6,2.6L345.7,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3524_",
    className: "st16",
    d: "M354.9,159.2c3.8,0.7,6.5,4.2,6.3,8c-0.1,1.3-0.5,2.4-1.1,3.4c-1.4,2.5-2.5,4.6-3.7,6 c-1.3,1.5-2,3.3-1.9,5.2l0.1,2c-4.7,1.7-6.5,0.5-6.5,0.5l0.7-5.7l0,0c-4.7-1.1-3.1-9.9-2.8-12.5l0,0c0-0.1,0-0.2,0-0.3 C346.4,161.5,350.5,158.4,354.9,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3523_",
    className: "st12",
    d: "M354.6,167c1.2,1.7,2.4,3.5,3.2,5.4c0.1,0.2,0.7,1.8,0.5,1.9c1.3-0.8,2.3-2.1,3.1-3.4 c1.4-2.3,1.4-5.3,0.3-7.7c-1.1-2.4-3.4-3.8-5.9-4.3c-2.7-0.5-5.9,0-7.8,2.2c-1.8,2-2.2,4.7-2.7,7.3c0.5-2.9,4.7-4.6,7.1-5.3 c-0.1,0,1.4,2.7,1.5,2.8C354.1,166.2,354.3,166.6,354.6,167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3522_",
    className: "st16",
    d: "M357.5,172.5c0.2-0.2,0.4-0.4,0.7-0.5c0.6-0.2,1.5-0.3,2.1,0.4c0.8,1-1.3,3.3-3.1,1.9 C357.2,174.4,356.7,173.8,357.5,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3521_",
    className: "st37",
    d: "M347,169.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 C347.2,170.6,347,170.3,347,169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3520_",
    className: "st37",
    d: "M353.2,171.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 C353.4,172,353.2,171.7,353.2,171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3519_",
    className: "st39",
    d: "M347.6,174.6c0,0,0.9-0.6,1.2-0.5c0.3,0.1,0.5,0.5,0.5,0.5s0.2-0.4,0.6-0.4 c0.4,0,1.3,1.2,1.3,1.2s-1.2,1.8-2.5,1.5C347.5,176.6,347.6,174.7,347.6,174.6L347.6,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3518_",
    className: "st12",
    d: "M355.3,170.5c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.3,0-0.4c0,0-0.8-0.8-2-0.9 c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3c1,0.1,1.7,0.7,1.7,0.8C355.1,170.5,355.2,170.5,355.3,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3517_",
    className: "st12",
    d: "M348.9,168.6c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0-0.3-0.1-0.4c0,0-1-0.6-2.2-0.4 c-0.2,0-0.3,0.2-0.2,0.3c0,0.2,0.2,0.3,0.3,0.2c1-0.2,1.8,0.3,1.8,0.3C348.7,168.6,348.8,168.6,348.9,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3516_",
    className: "st38",
    d: "M349.9,173.5c-0.8-0.2-1-0.8-1-1.2c0-0.1,0-0.1,0.1-0.2c0.8-0.8,0.9-2,0.9-2.1 c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,1.4-0.9,2.3c0,0.2,0.2,0.6,0.9,0.7c0.1,0,0.2,0.1,0.2,0.2 c0,0.1-0.1,0.2-0.2,0.2C350.1,173.6,350,173.5,349.9,173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3515_",
    className: "st40",
    d: "M347.6,174.6l3.6,0.8c0,0-1.4,0.9-2.4,0.7C347.9,175.9,347.6,174.6,347.6,174.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3510_",
    className: "st6",
    d: "M354.8,201.9c3.4,0,4.8-3.4,4.8-3.4c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0.1 c0,0-1.4,3.3-4.6,3.3c-3.2,0-4.5-2.4-4.5-2.4c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.1,0.2 C350.1,199.4,351.4,201.9,354.8,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3509_",
    className: "st6",
    d: "M339.6,197.4c0.1,0,0.1,0,0.1-0.1c0,0,0.3-2.3,2.1-3.9c0.1,0,0.1-0.1,0-0.2 c0-0.1-0.1-0.1-0.2,0c-1.8,1.7-2.1,4-2.1,4.1C339.5,197.3,339.5,197.4,339.6,197.4C339.6,197.4,339.6,197.4,339.6,197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3506_",
    className: "st7",
    d: "M347.3,215.9c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2 C348.3,218.1,347.3,217.1,347.3,215.9z M348.3,215.9c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2 C348.8,214.7,348.3,215.3,348.3,215.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3538_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_798_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.2454,
    y1: 129.7637,
    x2: 309.9218,
    y2: 197.2383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4137"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3541_",
    className: "st26",
    d: "M376.9,221.9l-65.4-35.2c6.3-15.8-0.2-34.3-15.6-42.5c-16.6-8.9-37.3-2.7-46.2,13.9 c-8.9,16.6-2.7,37.3,13.9,46.2c15.4,8.3,34.3,3.5,44.1-10.5l65.4,35.2L376.9,221.9z M266.4,199.3c-13.8-7.4-19-24.7-11.6-38.5 c7.4-13.8,24.7-19,38.5-11.6c13.8,7.4,19,24.7,11.6,38.5C297.4,201.5,280.2,206.7,266.4,199.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3540_",
    className: "st42",
    d: "M293.3,149.3c-13.8-7.4-31-2.2-38.5,11.6c-7.4,13.8-2.2,31,11.6,38.5 c13.8,7.4,31,2.2,38.5-11.6C312.3,173.9,307.1,156.7,293.3,149.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3539_",
    className: "st43",
    d: "M283,153.2c6.8,0,12.9,2.7,17.4,7.1c-4.4-6.8-12-11.3-20.7-11.3 c-13.6,0-24.7,11-24.7,24.7c0,6.9,2.8,13.1,7.3,17.5c-2.5-3.9-4-8.5-4-13.4C258.3,164.3,269.4,153.2,283,153.2z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3498_",
    className: "st16",
    d: "M315.3,200.3c0,0,2-3.2,1.6-3.6c-0.4-0.3-2.5,1.8-2.5,1.8c0,0,1.9-2.7,1.5-3.3 c-0.4-0.6-2.7,1.9-2.7,1.9s1.9-2.3,1.6-2.7c-0.3-0.4-2.4,1.6-2.5,1.5c-0.1-0.1,1.8-1.7,1.4-2.3c-0.3-0.5-3.1,1.6-3,2.3 c0.1,0.7,0.8,0.8,0.8,0.8s0.3,1.2,0.9,1.4c0,0,0.9,1.4,1.6,1.1C313.9,199.2,314.2,200.7,315.3,200.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3500_",
    className: "st16",
    d: "M366.9,214.5c0,0-3,1.5-4,2.1c-1,0.6-2.5,0.5-2.3,1.1c0.1,0.7,2.4,0.4,2.4,0.4 s-1.3,2.1-1.8,2.6c-0.5,0.6-1.1,1.8-0.7,2.2c0.4,0.4,2.5-2.5,2.5-2.5s-1.6,2.6-1.3,3.1c0.3,0.4,2.8-2.6,2.8-2.6s-1.8,2.7-1.8,3.1 c0,0.3,0.5,0.3,1.4-0.5c0.9-0.8,1.6-1.9,1.6-1.9s-1.1,2-1.2,2.3c-0.1,0.3,0.1,0.7,1.3-0.6c1.2-1.3,3.2-4.6,3.6-6.6L366.9,214.5z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_6"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNotfound);
export default __webpack_public_path__ + "static/media/illustration-notfound.cd0a1889ba48fc4d1b1bc36bbc87bb48.svg";
export { ForwardRef as ReactComponent };